import { useMutation } from '@tanstack/react-query'
import { postAddBusinessCustomer } from 'services/CustomerService'

export const useAddBusinessCustomer = () => {
  return useMutation({
    mutationFn: postAddBusinessCustomer,
  })
}
